import { t } from "components/CentralDataMangement/translation/Translation";

export const initialState = {
  tabDetails: [
    {
      id: "general",
      title: t("General and work agreements"),
      showStatus: false,
      error: false,
      draft: false,
    },
    {
      id: "contacts",
      title: t("Encoding User"),
      showStatus: false,
      error: false,
      draft: false,
    },
    {
      id: "shiftTables",        
      title: t("Time table"),
      showStatus: false,
      error: false,
      draft: false,
    },
    {
      id: "wage",
      title: t("Wage and premiums"),
      showStatus: false,
      error: false,
      draft: false,
    },
    {
      id: "others",
      title: t("Others"),
      showStatus: false,
      error: false,
      draft: false,
    },
  ],
  general: {
    company: null,
    companyId: null,
    vatNumber: "",
    iso: "",
    paritairBlue: [],
    paritairWhite: [],
    nssoCatg: [],
    encodage: null,
    syndicatedDelig: null,
    syndicatedDeligDate: null,
    vca: null,
    agreementList: null,
    isContracts: null,
    isContractsPerSem: null,
    largeFlex: false,
    smallFlex: false,
    other: false,
    otherExtraInfo: "",
    // restFreeTake: null,
    // restCollectivePlaced: null,
    // restCombination: null,
    // leaveFreeTake: null,
    // leaveCollectivePlaced: null,
    // leaveCombination: null,
    catchUpRest: null,
    leaves: null,
    catchupRestExtraData: [{ fromDate: null, toDate: null, info: "" }],
    leavesExtraData: [{ fromDate: null, toDate: null, info: "" }],
    explicitRegime: null,
    exemptionBV: [],
    extraInfo: "",
    isKBApplicable: null,
    // KBData: [
    //   {
    //     hours: "",
    //     percentage: "",
    //   },
    // ],
    electronicInvoice: "0",
    electronicInvoiceMail: "",
    electronicContract: "0",
    electronicContractMail: "",
    // performanceSheet: false,
    // performanceSheetMail: "",
    reminderMail: "",
    status: null,
    coeffType: "",
  },
  signatoryList: [],
  contacts: [],
  selectedContact: [],
  dynamicErrors: [
    {
      fName: "",
      lName: "",
      email: "",
      phNumber: "",
      teleNumber: "",
      dob: "",
      gsm: "",
      contact: "",
      functionTitle: "",
      linkedIn: "",
      roles: "",
      language: "",
      decisionMaker: "",
      influencer: "",
      contactCalled: "",
      contactEmailed: "",
      info: "",
      title: "",
      location: "",
    },
  ],
  shiftTables: [],
  wageAndPremiums: [],
  commProfileList: [],
  nssoCategoryList: [],
  rolesList: [],
  perfCodeList: [],
  pcLinkedPerfCodeList: [],
  vcaList: [],
  agreementList: [],
  regimeList: [],
  shiftList: [],
  autoTypeList: [],
  workRegimeList: [],
  ecoBenefitList: [],
  contactList: [],
  languages: [],
  genders: [],
  virtueList: [],
  pcEcoAndMealValues: [],
  initialWageAndPremiums: [],
  errors: {
    syndicatedDelig: "",
    vca: "",
    nssoCatg: "",
    catchUpRest: "",
    leaves: "",
    explicitRegime: "",
    exemptionBV: "",
    isKBApplicable: "",
    selectedContact: "",
  },
  others: {
    extraInfo: "",
  },
};
